import React from 'react';
import { createRoot } from 'react-dom/client'; // Ensure React 18+
import './index.css';
import App from './App';
import { Web3ReactProvider } from "@web3-react/core";
import { Provider } from "react-redux";
import { hooks as walletConnectV2Hooks, walletConnectV2 } from './connectors/walletConnectV2.js';
import { hooks as metaMaskHooks, metaMask } from './connectors/metaMask';
import store from './redux/store/store.js';
import useEagerConnect from './hooks/useEagerConnect.js';

const Web3Wrapper = ({ children }) => {
  useEagerConnect();
  return children;
};

const connectors = [
  [walletConnectV2, walletConnectV2Hooks],
  [metaMask, metaMaskHooks]
];

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Web3ReactProvider connectors={connectors}>
        <Web3Wrapper>
          <App />
        </Web3Wrapper>
      </Web3ReactProvider>
    </Provider>
  </React.StrictMode>
);
